import React from 'react';
import SideTabsLayout from '@/shared/components/SideTabsLayout';

export const EVAL_VIEW_TABS = {
  OVERVIEW: 'overview',
  SAMPLES: 'samples',
  PERFORMANCE: 'performance',
};

const DEFAULT_ITEMS = [
  { id: EVAL_VIEW_TABS.OVERVIEW, label: 'Overview' },
  { id: EVAL_VIEW_TABS.SAMPLES, label: 'Samples' },
  { id: EVAL_VIEW_TABS.PERFORMANCE, label: 'Performance' },
];

/**
 * Top-level evaluation view tabs (Overview / Samples / Performance) as a
 * vertical side rail with the active view rendered to its right — the same
 * shared layout used by the Data Editor tab.
 *
 * The right content pane sits on a white CardSurface; the left rail stays on
 * the page canvas.
 *
 * @param {Object} props
 * @param {boolean} [props.show] When false, renders the children without the
 *   rail (loading / NER-with-relations / empty states keep their layout).
 * @param {string} props.activeTab
 * @param {(id: string) => void} props.onChange
 * @param {{id: string, label: string}[]} [props.items]
 * @param {React.ReactNode} props.children Content of the active view.
 */
export default function EvaluationViewTabs({ show = true, activeTab, onChange, items = DEFAULT_ITEMS, children }) {
  return (
    <SideTabsLayout
      show={show}
      withCard
      items={items}
      activeId={activeTab}
      onChange={onChange}
    >
      {children}
    </SideTabsLayout>
  );
}
